import { M8Promocode } from 'services/production/types';
import { Promocode } from 'types/state/promocode';
import { createOrg } from 'utils/orgUtils';
import { createPerson } from 'utils/personUtils';

export const normalizeM8Promocode = (m8Promocode: M8Promocode) => ({
  toPromocode(): Promocode {
    let org = null;

    if (m8Promocode.organization) {
      org = createOrg();
      org.name = m8Promocode.organization;
    }

    let person = null;

    if (m8Promocode.fio) {
      person = createPerson();
      person.firstName = m8Promocode.fio;
    }

    return {
      id: m8Promocode.id,
      value: m8Promocode.code,
      activatedBy:
        m8Promocode.promocodeStatus === 'ACTIVATED_BY_CLIENT'
          ? 'CLIENT'
          : m8Promocode.promocodeStatus === 'ACTIVATED_BY_PARTNER'
          ? 'PARTNER'
          : null,
      activatedAtTimestamp:
        m8Promocode.activationDate !== null
          ? new Date(m8Promocode.activationDate).getTime()
          : null,
      createdAtTimestamp: new Date(m8Promocode.createdOn).getTime(),
      extiresAtTimestamp: new Date(m8Promocode.validUntil).getTime(),
      org,
      person,
    };
  },
});
